import type { GetAdminDetailsResponse, GetUserDetailsResponse } from "../../../../users/userApi"

import { CompanyUserDetails, CompanyUserDetailsType } from "./companyUserDetailsTypes"

export function toCompanyUserDetails({ user, logins }: GetUserDetailsResponse): CompanyUserDetails {
    return {
        type: CompanyUserDetailsType.USER,
        id: user.id,
        displayName: user.displayName,
        displayInitials: user.displayInitials,
        email: user.email,
        username: user.username,
        employeeId: user.employeeId,
        userGroupName: user.userGroup?.name,
        departmentName: user.department?.name,
        phone: user.phoneNumber || user.mobileNumber,
        language: user.language,
        syncDetails: user.userGroup?.syncDetails,
        logins,
        roles: user.roles ?? [],
    }
}

export function toCompanyAdminDetails({ admin }: GetAdminDetailsResponse): CompanyUserDetails {
    const { user } = admin

    return {
        type: CompanyUserDetailsType.ADMIN,
        id: user.id,
        displayName: user.displayName,
        displayInitials: user.displayInitials,
        email: user.email,
        username: user.username,
        phone: user.phoneNumber || user.mobileNumber,
        language: user.language,
        roles: admin.roles ?? [],
    }
}
